import { Component, OnInit, Input,Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-patient-list-card',
  templateUrl: './patient-list-card.component.html',
  styleUrls: ['./patient-list-card.component.css']
})
export class PatientListCardComponent implements OnInit {

  constructor() { }

  @Input() patientList;
  @Output() openAction = new EventEmitter();
  @Output() shareAction = new EventEmitter();
  @Output() copyAction = new EventEmitter();
  @Output() listAction = new EventEmitter();

  ngOnInit() {
  }

  open(value) {
    this.openAction.emit(value);
  }

  share(data) {

    this.shareAction.emit(data);

  }

  copy(data) {

    this.copyAction.emit(data);

  }

  showList(data) {
    this.listAction.emit(data);

  }



}
